// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import Naluri from '~/common/api/naluri'
import {
  PROGRESS_DELETE_WEIGHING,
} from './constants';

export function deleteWeighing(id) {
  return (dispatch) => {
    Naluri.delete(`/api/expert/weighings/${id}`)
    .then(res => {
      dispatch({
        type: PROGRESS_DELETE_WEIGHING,
        payload: id
      })
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PROGRESS_DELETE_WEIGHING:
      const newList = state.weighings.filter(weighing => {
        return weighing.id !== action.payload;
      });

      return {
        ...state,
        weighings: newList
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/progress/redux/deleteWeighing.js